import "regenerator-runtime/runtime";
import { put, call, takeEvery, takeLatest, all } from "redux-saga/effects";
import { AppSettings } from "../constants";

import {
  create,
  createScheduleWorkOrder,
  getWorkOrdersByRFSID,
  getWorkOrderDetail,
  getAllUsersEmail,
  updateWorkOrder,
  openAwaitingWorkOrder,
  BulkUpdateMultipleWO,
  resolveWorkOrder,
  signoffWorkOrder,
  declineWorkOrder,
  pendWorkOrder,
  openPendingWorkOrder,
  pendingOpenWorkOrder,
  reOpenWorkOrder,
  reviewReOpenWorkOrder,
  getWorkOrderComments,
  addWorkOrderComment,
  submitDeclinedWorkOrder,
  editRequestedReOpenWorkOrder,
  workOrderAwsCredential,
  uploadWorkOrderFile,
  uploadToServer,
  updateCaptionAttachmentWorkOrder,
  dowloadFileFromS3,
  searchSubcontractorWorkOrders,
  resolveSubcontractorWorkOrder,
  printPreviewWorkOrder,
  printPreviewSubcontractorWorkOrder,
  resendNotice,
  signOffuploadAttachmentToS3,
  signOffUploadAttachmentToServer,
  subcontractorWorkOrderAwsCredential,
  searchWorkOrderList,
  getBackChargeDetail,
  getBackChargeListOfPurchaseOrder,
  createBackCharge,
  editBackCharge,
  getWorkOrderHistory,
  getGlobalWorkOrderDetail,
  AddHomeownerWorkOrder,
  EditHomeownerWorkOrder,
  getHomeownerWorkOrderAwsCredential,
  reOpenHomeownerWorkOrder,
  signOffHomeownerWorkOrder,
  homeownerSetupAWS,
  submitDeclinedHomeownerWorkOrder,
  exportWorkOrderList,
  printPreviewHomeownerWorkOrder,
  pendingSubcontractorOpenWorkOrder,
  reassignMultipleWorkOrder,
  editSubcontractorWorkOrder,
  uploadSignatureHomeowner,
  checkHomeownerSignatureWO,
  saveFilterWO,
  savedFilterListWO,
  getSavedFilterWOValue,
  removeSavedFilterWO,
  editSavedFilterWO,
  getListContactInformation,
  editContactInformation,
  getListContactPointPrioritized,
  sendBulkMail,
  getWorkOrderPrivateNotes,
  deleteWorkOrderPrivateNote,
  sendEmailWODetail,
  getLastResolvedWorkOrder,
  resolveCloseDateUpdate,
  resolveCloseDateUpdateOnReopenAndNFA,
  getLotPaidFeature,
} from "./api";
import * as WorkOrderAction from "./constants";
import * as PunchListActionType from "../Punch-List/constants";
import * as RFSActionType from "../Request-Services/constants";
import * as NotifyActionType from "../Notification/constants";
import * as LotActionType from "../Lots/constants";

function* getRFSOrPunchListAsync(rfsRefNo) {
  const pathname = window.location.pathname.split("/")[1];

  if (pathname === "request-for-services") {
    yield put({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: rfsRefNo,
    });
  } else {
    yield put({
      type: PunchListActionType.GET_PUNCH_LIST_DETAIL_ASYNC,
      params: { refNo: rfsRefNo },
    });
  }
}

export function* createAsync(action) {
  const result = yield call(create, action.params.data);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.CREATE_WORK_ORDER_SUCCESS,
        data: {
          isRedirect: action.params.isRedirectToEdit,
          refNo: result.data.refNo,
          workOrderProfile: result.data,
        },
      }),
      // put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Work order created' })
    ];
    action.callback(result.data);
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data,
    });
  }
}

export function* sendBulkMailAsync(action) {
  const result = yield call(sendBulkMail, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Email sent",
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data,
    });
  }
}

export function* createAndSendAsync(action) {
  const result = yield call(create, action.params.data);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
        params: {
          isRedirect: action.params.isRedirectToEdit,
          from: "create",
          refNo: result.data.refNo,
          data: {
            status: "Open",
            tradeId: action.params.data.tradeId,
            itemToRepairId: action.params.data.itemToRepairId,
            subcontractorId: action.params.data.subcontractorId,
            workOrderTypeId: action.params.data.workOrderTypeId,
            problemId: action.params.data.problemId,
            assignedUserId: action.params.data.assignedUserId,
          },
        },
      }),
    ];
    action.callback(result.data);
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data,
    });
  }
}

export function* createScheduleWorkOrderAsync(action) {
  const result = yield call(createScheduleWorkOrder, action.params.data);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.CREATE_WORK_ORDER_SUCCESS,
        data: {
          isRedirect: action.params.isRedirectToEdit,
          refNo: result.data.refNo,
          workOrderProfile: result.data,
        },
      }),
      // put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Work order created' })
    ];
    action.callback(result.data);
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data,
    });
  }
}

// export function* uploadAsync(action) {
//   const result = yield call(upload, action.params.files);
//   if (action.params.callBack) {action.params.callBack(result.data);}
// }

export function* getWorkOrdersByRFSIDAsync(action) {
  const result = yield call(getWorkOrdersByRFSID, action.ID, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_WORK_ORDER_BY_RFSID_SUCCESS,
      data: {
        data: result.data,
        params: action.params,
      },
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data,
    });
  }
}

export function* getWorkOrderDetailAsync(action) {
  const result = yield call(getWorkOrderDetail, action.params);
  let error;

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS,
        data: result.data,
      }),
      put({
        type: LotActionType.GET_LOT_BY_ID_ASYNC,
        params: result.data.workOrder.lot.id,
      }),
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (action.error) {
      if (statusCode === 500) {
        error = true;
      }
      action.error(result.data.error);
    }
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: error ? result.data : result.data[0],
    });
  }
}

export function* getAllUsersEmailAsync(action) {
  const result = yield call(getAllUsersEmail, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_ALL_USER_EMAILS_SUCCESS,
        data: result.data,
      }),
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (action.error) {
      action.error("error");
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateWorkOrderAsync(action) {
  const result = yield call(updateWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.UPDATE_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* openAwaitingWorkOrderAsync(action) {
  const result = yield call(openAwaitingWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.params.from === "create") {
      yield [
        put({
          type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
          data: result.data,
          IsRedirectToEdit: action.params.isRedirect,
        }),
        put({
          type: NotifyActionType.NOTIFY_SUCCESS,
          data: "Work order created and sent",
        }),
      ];
      if (action.callback) {
        action.callback();
      }
    } else {
      yield [
        put({
          type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
          data: result.data,
        }),
        put({
          type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
          data: result.data,
        }),
        put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
      ];
      if (action.callback) {
        action.callback();
      }
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}
// BULK_UPDATE_MULTIPLE_WO
export function* BulkUpdateMultipleWOAsync(action) {
  const { data, statusCode } = yield call(BulkUpdateMultipleWO, action.params);
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Sent" })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
  }
}

export function* resolveWorkOrderAsync(action) {
  const result = yield call(resolveWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    // if (action.params.comment !== '') {
    //   const addComment = yield call(addWorkOrderComment, {
    //     workOrderId: action.params.refNo,
    //     rfsId: action.params.rfsRefNo,
    //     data: {comment: action.params.comment}
    //   });
    //   if (addComment.statusCode === 200) {
    //     yield put({
    //       type: WorkOrderAction.GET_WORK_ORDER_COMMENTS_ASYNC,
    //       params: {
    //         workOrderId: action.params.refNo,
    //         rfsId: action.params.rfsRefNo,
    //         data: {
    //           skip: 0,
    //           take: 10
    //         }
    //       }
    //     });
    //   }
    // }
    if (action.callback) {
      action.callback();
    }
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* signoffWorkOrderAsync(action) {
  const result = yield call(signoffWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield call(() => getRFSOrPunchListAsync(action.params.rfsId));

    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* declineWorkOrderAsync(action) {
  const result = yield call(declineWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield call(() => getRFSOrPunchListAsync(action.params.rfsId));

    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* pendWorkOrderAsync(action) {
  const result = yield call(pendWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* openPendingWorkOrderAsync(action) {
  const result = yield call(openPendingWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* pendingOpenWorkOrderAsync(action) {
  const result = yield call(pendingOpenWorkOrder, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* reOpenWorkOrderAsync(action) {
  const result = yield call(reOpenWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield call(() => getRFSOrPunchListAsync(action.params.rfsId));

    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* reviewReOpenWorkOrderAsync(action) {
  const result = yield call(reviewReOpenWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield call(() => getRFSOrPunchListAsync(action.params.rfsId));

    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getWorkOrderCommentsAsync(action) {
  let error;
  const result = yield call(getWorkOrderComments, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_WORK_ORDER_COMMENTS_SUCCESS,
        data: result.data,
      }),
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (statusCode === 500) {
      error = true;
    }
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: error ? result.data : result.data[0],
    });
  }
}

export function* getWorkOrderPrivateNotesAsync(action) {
  let error;
  const result = yield call(getWorkOrderPrivateNotes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_WORK_ORDER_PRIVATE_NOTES_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    if (statusCode === 500) {
      error = true;
    }
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: error ? result.data : result.data[0],
    });
  }
}

export function* addWorkOrderCommentAsync(action) {
  const result = yield call(addWorkOrderComment, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* deleteWorkOrderPrivateNotesAsync(action) {
  const result = yield call(deleteWorkOrderPrivateNote, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* submitDeclinedWorkOrderAsync(action) {
  const result = yield call(submitDeclinedWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield call(() => getRFSOrPunchListAsync(action.params.rfsId));

    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];

    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* editRequestedReOpenWorkOrderAsync(action) {
  const result = yield call(editRequestedReOpenWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updateCaptionAttachmentWorkOrderAsync(action) {
  const result = yield call(updateCaptionAttachmentWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* setupAWSAsync(action) {
  const result = yield call(workOrderAwsCredential, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SETUP_AWS_S3_SUCCESS,
      data: result.data,
    });

    setTimeout(() => {
      if (action.callback) {
        action.callback(result.data);
      }
    }, 500);
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* downloadFileFromS3Async(action) {
  yield call(dowloadFileFromS3, action.params, action.callback);
}

export function* uploadFileWorkOrderAsync(action) {
  const paramsUpload = {
    refNo: action.params.refNo,
    file: action.params.file,
    config: action.params.config,
  };
  yield call(uploadWorkOrderFile, paramsUpload, action.callback);
}
//upload signature in Subcontractor
export function* uploadHomeownerSignatureAsync(action) {
  const paramsUpload = {
    refNo: action.params.refNo,
    data: action.params.data,
    config: action.params.config,
  };
  yield call(uploadSignatureHomeowner, paramsUpload, action.callback);
}

export function* uploadToServerAsync(action) {
  const result = yield call(uploadToServer, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.UPLOAD_TO_SERVER_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (action.callback) {
      action.callback(result.data, false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* searchSubcontractorWorkOrdersAsync(action) {
  const result = yield call(searchSubcontractorWorkOrders, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SEARCH_SUBCONTRACTOR_WORK_ORDER_SUCCESS,
      data: { data: result.data, params: action.params },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* searchWorkOrderListAsync(action) {
  const result = yield call(searchWorkOrderList, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SEARCH_WORK_ORDER_LIST_SUCCESS,
      data: { data: result.data, params: action.params },
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] }),
      put({ type: WorkOrderAction.SEARCH_WORK_ORDER_LIST_FAIL }),
    ];
  }
}

export function* printPreviewWorkOrderAsync(action) {
  const result = yield call(printPreviewWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resendNoticeAsync(action) {
  const result = yield call(resendNotice, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Notice sent" });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* signOffUploadAttachmentToS3Async(action) {
  const paramsUpload = {
    refNo: action.params.refNo,
    file: action.params.file,
    config: action.params.config,
  };
  yield call(signOffuploadAttachmentToS3, paramsUpload, action.callback);
}

export function* signOffUploadAttachmentToServerAsync(action) {
  const result = yield call(signOffUploadAttachmentToServer, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (process.env.NODE_ENV === "development") {
      console.log("Sign off attachment status 200");
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getBackChargeListOfPurchaseOrderAsync(action) {
  const result = yield call(getBackChargeListOfPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
    yield put({
      type: WorkOrderAction.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_SUCCESS,
      data: result.data,
    });
  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield [
      put({
        type: WorkOrderAction.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_FAIL,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
    ];
  }
}

export function* getBackChargeDetailAsync(action) {
  const result = yield call(getBackChargeDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
    yield put({
      type: WorkOrderAction.GET_BACK_CHARGE_DETAIL_SUCCESS,
      data: result.data,
    });
  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield [
      put({
        type: WorkOrderAction.GET_BACK_CHARGE_DETAIL_FAIL,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
    ];
  }
}

export function* createBackChargeAsync(action) {
  const result = yield call(createBackCharge, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data, true);
    }
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Back charge created",
    });
  } else {
    if (action.callback) {
      action.callback(result.data, false);
    }
    yield [
      put({ type: WorkOrderAction.CREATE_BACK_CHARGE_FAIL, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
    ];
  }
}

export function* editBackChargeAsync(action) {
  const result = yield call(editBackCharge, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
      put({
        type: WorkOrderAction.EDIT_BACK_CHARGE_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield [
      put({ type: WorkOrderAction.EDIT_BACK_CHARGE_FAIL, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
    ];
  }
}

// SUBCONTRACTOR

export function* printPreviewSubcontractorWorkOrderAsync(action) {
  const result = yield call(printPreviewSubcontractorWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* setupSubcontractorAWSAsync(action) {
  const result = yield call(subcontractorWorkOrderAwsCredential, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SETUP_AWS_S3_SUCCESS,
      data: result.data,
    });
    setTimeout(() => {
      if (action.callback) {
        action.callback();
      }
    }, 500);
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* resolveSubcontractorWorkOrdersAsync(action) {
  const result = yield call(resolveSubcontractorWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.RESOLVE_SUBCONTRACTOR_WORK_ORDER_SUCCESS,
        data: { workOrder: result.data },
      }),
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* pendingSubcontractorOpenWorkOrderAsync(action) {
  const result = yield call(pendingSubcontractorOpenWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_SUCCESS,
        data: { workOrder: result.data },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getGlobalWorkOrderDetailAsync(action) {
  const result = yield call(getGlobalWorkOrderDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      yield [
        put({
          type: WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS,
          data: result.data,
        }),
        put({
          type: LotActionType.GET_HOMEOWNER_LOT_DETAIL_ASYNC,
          params: {
            endpoint: result.data.builderProfile.lotDetailEndpoint,
            headers: {
              key: result.data.builderProfile.headerKey,
              value: result.data.builderProfile.securityToken,
            },
          },
        }),
      ];
    } else {
      yield [
        put({
          type: WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS,
          data: result.data,
        }),
      ];
    }

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
    if (action.error) {
      action.error();
    }
  }
}

export function* getWorkOrderHistoryAsync(action) {
  const result = yield call(getWorkOrderHistory, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_WORK_ORDER_HISTORY_SUCCESS,
      data: result.data,
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

// HOMEOWNERS

export function* printPreviewHomeownerWorkOrderAsync(action) {
  const result = yield call(printPreviewHomeownerWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* addHomeownerWorkOrderAsync(action) {
  const result = yield call(AddHomeownerWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* editHomeownerWorkOrderAsync(action) {
  const result = yield call(EditHomeownerWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
      put({
        type: WorkOrderAction.EDIT_HOMEOWNER_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* editSubcontractorWorkOrderAsync(action) {
  const result = yield call(editSubcontractorWorkOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.UPDATE_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getHomeownerWorkOrderAwsCredentialAsync(action) {
  const result = yield call(getHomeownerWorkOrderAwsCredential, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SETUP_AWS_S3_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* reOpenHomeownerWorkOrderAsync(action) {
  const result = yield call(reOpenHomeownerWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* signOffHomeownerWorkOrderAsync(action) {
  const result = yield call(signOffHomeownerWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* homeownerSetupAWSAsync(action) {
  const result = yield call(homeownerSetupAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.SETUP_AWS_S3_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* submitDeclinedHomeownerWorkOrderAsync(action) {
  const result = yield call(submitDeclinedHomeownerWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* exportWorkOrderListFunc(action) {
  const result = yield call(exportWorkOrderList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.params.Recipients.length > 0) {
      yield [
        put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Email sent" }),
      ];

      if (action.callback) {
        action.callback();
      }
    } else {
      //get file name
      let filename = "WorkOrders.xlsx";
      let disposition = result.headers["content-disposition"];

      if (disposition) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);

        if (matches !== null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      let blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (window.navigator.msSaveOrOpenBlob) {
        // for IE browser
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // for Non-IE (chrome, firefox etc.)
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reassignMultipleWorkOrderAsync(action) {
  const result = yield call(reassignMultipleWorkOrder, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* checkHomeownerSignatureWOAsync(action) {
  const result = yield call(checkHomeownerSignatureWO, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.CHECK_HOMEOWNER_SIGNATURE_WO_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* savedFilterListWOAsync(action) {
  const result = yield call(savedFilterListWO, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_SAVED_FILTERED_WO_LIST_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* saveFilterWOAsync(action) {
  const result = yield call(saveFilterWO, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Saved",
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* getSavedFilterWOValueAsync(action) {
  const result = yield call(getSavedFilterWOValue, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_SAVED_FILTERED_WO_VALUE_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback({ SelectedFilterName: result.data.name });
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* removeSavedFilterWOAsync(action) {
  const result = yield call(removeSavedFilterWO, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Removed",
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}
getListContactInformation;
export function* editSavedFilterWOAsync(action) {
  const result = yield call(editSavedFilterWO, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Saved",
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}
editContactInformation;
export function* getListContactInformationAsync(action) {
  const result = yield call(getListContactInformation, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_CONTACT_INFO_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* editContactInformationAsync(action) {
  const result = yield call(editContactInformation, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Edited",
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}

export function* getListContactPointPrioritizedAsync(action) {
  const result = yield call(getListContactPointPrioritized, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderAction.GET_LIST_CONTACT_PRIORITIZED_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}
export function* sendEmailWODetailAsync(action) {
  const result = yield call(sendEmailWODetail, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Email sent",
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error,
    });
  }
}
export function* getLastResolvedWorkOrderAsync(action) {
  const result = yield call(getLastResolvedWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_LAST_RESOLVED_WORK_ORDER_SUCCESS,
        data: result.data,
      }),
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (action.error) {
      action.error("error");
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}
export function* resolveCloseDateUpdateAsync(action) {
  const result = yield call(resolveCloseDateUpdate, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    console.log("Resolve Close Date Update in RFS");
  } else {
    if (action.error) {
      action.error("error");
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* resolveCloseDateUpdateOnReopenAndNFAAsync(action) {
  const result = yield call(
    resolveCloseDateUpdateOnReopenAndNFA,
    action.params
  );

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    console.log("Resolve Close Date Update in RFS");
  } else {
    if (action.error) {
      action.error("error");
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getLotPaidFeatureAsync(action) {
  const { data, statusCode } = yield call(getLotPaidFeature);
  if (statusCode === 200) {
    yield [
      put({
        type: WorkOrderAction.GET_LOT_PAID_FEATURE_SUCCESS,
        data: data,
      }),
    ];
    if (action.callback) {
      action.callback(data, true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
    if (action.callback) {
      action.callback(data, false);
    }
  }
}

export default function* WatchWorkOrder() {
  yield all([
    takeEvery(WorkOrderAction.CREATE_WORK_ORDER_ASYNC, createAsync),
    takeEvery(
      WorkOrderAction.CREATE_SCHEDULE_WORK_ORDER_ASYNC,
      createScheduleWorkOrderAsync
    ),
    takeEvery(WorkOrderAction.SEND_BULK_MAIL_ASYNC, sendBulkMailAsync),
    takeLatest(
      WorkOrderAction.CREATE_AND_SEND_WORK_ORDER_ASYNC,
      createAndSendAsync
    ),
    takeLatest(WorkOrderAction.GET_ALL_USER_EMAILS, getAllUsersEmailAsync),
    // takeEvery(WorkOrderAction.UPLOAD_WORK_ORDER_ASYNC, uploadAsync),
    takeLatest(
      WorkOrderAction.GET_WORK_ORDER_BY_RFSID,
      getWorkOrdersByRFSIDAsync
    ),
    takeEvery(
      WorkOrderAction.GET_WORK_ORDER_DETAIL_ASYNC,
      getWorkOrderDetailAsync
    ),
    takeLatest(WorkOrderAction.UPDATE_WORK_ORDER_ASYNC, updateWorkOrderAsync),
    takeLatest(
      WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
      openAwaitingWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.BULK_UPDATE_MULTIPLE_WO_ASYNC,
      BulkUpdateMultipleWOAsync
    ),
    takeLatest(WorkOrderAction.RESOLVE_WORK_ORDER_ASYNC, resolveWorkOrderAsync),
    takeLatest(
      WorkOrderAction.SIGN_OFF_WORK_ORDER_ASYNC,
      signoffWorkOrderAsync
    ),
    takeLatest(WorkOrderAction.DECLINE_WORK_ORDER_ASYNC, declineWorkOrderAsync),
    takeLatest(WorkOrderAction.PEND_WORK_ORDER_ASYNC, pendWorkOrderAsync),
    takeLatest(
      WorkOrderAction.OPEN_PENDING_WORK_ORDER_ASYNC,
      openPendingWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.PENDING_OPEN_WORK_ORDER_ASYNC,
      pendingOpenWorkOrderAsync
    ),
    takeLatest(WorkOrderAction.RE_OPEN_WORK_ORDER_ASYNC, reOpenWorkOrderAsync),
    takeLatest(
      WorkOrderAction.REVIEW_RE_OPEN_WORK_ORDER_ASYNC,
      reviewReOpenWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.GET_WORK_ORDER_COMMENTS_ASYNC,
      getWorkOrderCommentsAsync
    ),
    takeLatest(
      WorkOrderAction.GET_WORK_ORDER_PRIVATE_NOTES_ASYNC,
      getWorkOrderPrivateNotesAsync
    ),
    takeLatest(
      WorkOrderAction.ADD_WORK_ORDER_COMMENTS_ASYNC,
      addWorkOrderCommentAsync
    ),
    takeLatest(
      WorkOrderAction.DELETE_WORK_ORDER_PRIVATE_NOTES_ASYNC,
      deleteWorkOrderPrivateNotesAsync
    ),

    takeLatest(
      WorkOrderAction.SUBMIT_DECLINED_WORK_ORDER_ASYNC,
      submitDeclinedWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC,
      editRequestedReOpenWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_ASYNC,
      updateCaptionAttachmentWorkOrderAsync
    ),
    takeLatest(WorkOrderAction.SETUP_AWS_S3_ASYNC, setupAWSAsync),
    takeLatest(
      WorkOrderAction.UPLOAD_FILE_WORK_ORDER_ASYNC,
      uploadFileWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.UPLOAD_SIGNATURE_WORK_ORDER_ASYNC,
      uploadHomeownerSignatureAsync
    ),
    takeEvery(WorkOrderAction.UPLOAD_TO_SERVER_ASYNC, uploadToServerAsync),
    takeLatest(WorkOrderAction.DOWNLOAD_FILE_FROM_S3, downloadFileFromS3Async),
    takeLatest(
      WorkOrderAction.SEARCH_WORK_ORDER_LIST_ASYNC,
      searchWorkOrderListAsync
    ),
    takeLatest(
      WorkOrderAction.SEARCH_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      searchSubcontractorWorkOrdersAsync
    ),
    takeLatest(
      WorkOrderAction.RESOLVE_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      resolveSubcontractorWorkOrdersAsync
    ),
    takeLatest(
      WorkOrderAction.PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_ASYNC,
      pendingSubcontractorOpenWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.PRINT_PREVIEW_WORK_ORDER_ASYNC,
      printPreviewWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.PRINT_PREVIEW_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      printPreviewSubcontractorWorkOrderAsync
    ),
    takeLatest(WorkOrderAction.RESEND_NOTICE_ASYNC, resendNoticeAsync),
    takeLatest(
      WorkOrderAction.SIGN_OFF_UPLOAD_ATTACHMENT_TO_S3_ASYNC,
      signOffUploadAttachmentToS3Async
    ),
    takeLatest(
      WorkOrderAction.SIGN_OFF_UPLOAD_ATTACHMENT_TO_SERVER_ASYNC,
      signOffUploadAttachmentToServerAsync
    ),
    takeLatest(WorkOrderAction.GET_LOT_PAID_FEATURE, getLotPaidFeatureAsync),
    takeLatest(
      WorkOrderAction.SETUP_SUBCONTRACTOR_AWS_S3_ASYNC,
      setupSubcontractorAWSAsync
    ),
    takeLatest(
      WorkOrderAction.GET_BACK_CHARGE_DETAIL_ASYNC,
      getBackChargeDetailAsync
    ),
    takeLatest(
      WorkOrderAction.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_ASYNC,
      getBackChargeListOfPurchaseOrderAsync
    ),
    takeLatest(WorkOrderAction.CREATE_BACK_CHARGE_ASYNC, createBackChargeAsync),
    takeLatest(WorkOrderAction.EDIT_BACK_CHARGE_ASYNC, editBackChargeAsync),
    takeLatest(
      WorkOrderAction.GET_WORK_ORDER_HISTORY_ASYNC,
      getWorkOrderHistoryAsync
    ),
    takeLatest(
      WorkOrderAction.GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC,
      getGlobalWorkOrderDetailAsync
    ),
    takeLatest(
      WorkOrderAction.ADD_HOMEOWNER_WORK_ORDER_ASYNC,
      addHomeownerWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.EDIT_HOMEOWNER_WORK_ORDER_ASYNC,
      editHomeownerWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.SETUP_HOMEOWNER_AWS_S3_ASYNC,
      getHomeownerWorkOrderAwsCredentialAsync
    ),
    takeLatest(
      WorkOrderAction.RE_OPEN_HOMEOWNER_WORK_ORDER_ASYNC,
      reOpenHomeownerWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.SIGN_OFF_HOMEOWNER_WORK_ORDER_ASYNC,
      signOffHomeownerWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.HOMEOWNER_SETUP_AWS_S3_ASYNC,
      homeownerSetupAWSAsync
    ),
    takeLatest(
      WorkOrderAction.SUBMIT_DECLINED_HOMEOWNER_WORK_ORDER_ASYNC,
      submitDeclinedHomeownerWorkOrderAsync
    ),
    takeLatest(WorkOrderAction.EXPORT_WORK_ORDER_LIST, exportWorkOrderListFunc),
    takeLatest(
      WorkOrderAction.PRINT_PREVIEW_HOMEOWNER_WORK_ORDER_ASYNC,
      printPreviewHomeownerWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.REASSIGN_MULTIPLE_WORK_ORDER_ASYNC,
      reassignMultipleWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.EDIT_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      editSubcontractorWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.CHECK_HOMEOWNER_SIGNATURE_WO_ASYNC,
      checkHomeownerSignatureWOAsync
    ),
    takeLatest(WorkOrderAction.SAVE_FILTER_WO_ASYNC, saveFilterWOAsync),
    takeLatest(
      WorkOrderAction.GET_SAVED_FILTERED_WO_LIST_ASYNC,
      savedFilterListWOAsync
    ),
    takeLatest(
      WorkOrderAction.GET_SAVED_FILTERED_WO_VALUE_ASYNC,
      getSavedFilterWOValueAsync
    ),
    takeLatest(
      WorkOrderAction.REMOVE_SAVED_FILTERED_WO_ASYNC,
      removeSavedFilterWOAsync
    ),
    takeLatest(
      WorkOrderAction.EDIT_SAVED_FILTERED_WO_ASYNC,
      editSavedFilterWOAsync
    ),
    takeLatest(
      WorkOrderAction.GET_CONTACT_INFO_ASYNC,
      getListContactInformationAsync
    ),
    takeLatest(
      WorkOrderAction.EDIT_CONTACT_INFO_ASYNC,
      editContactInformationAsync
    ),
    takeLatest(
      WorkOrderAction.GET_LIST_CONTACT_PRIORITIZED_ASYNC,
      getListContactPointPrioritizedAsync
    ),
    takeLatest(WorkOrderAction.SEND_EMAIL_WO_DETAIL, sendEmailWODetailAsync),
    takeLatest(
      WorkOrderAction.GET_LAST_RESOLVED_WORK_ORDER,
      getLastResolvedWorkOrderAsync
    ),
    takeLatest(
      WorkOrderAction.RESOLVE_CLOSE_DATE_UPDATE,
      resolveCloseDateUpdateAsync
    ),
    takeLatest(
      WorkOrderAction.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
      resolveCloseDateUpdateOnReopenAndNFAAsync
    ),
    takeLatest(
      PunchListActionType.GET_LOT_PAID_FEATURE,
      getLotPaidFeatureAsync
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/Work-Orders/saga.js